export const CollaboratorStatusEnum = Object.freeze({
  PENDING: 'pending',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  SUSPENDED: 'suspended',
});
